/**
 * Copy `text` to the clipboard, returning whether it succeeded.
 *
 * `navigator.clipboard.writeText` rejects on denied permission, a non-secure
 * context, or a lost-focus race. Callers must handle both outcomes (success
 * feedback vs. a recoverable manual-copy affordance), so this centralizes the
 * try/catch and hands back a plain boolean instead of a throwing promise.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
